import { useEffect, useState } from "react";
import { api } from "../../lib/api";

export default function Story() {
  const [story, setStory] = useState({ title: "", body: "" });
  useEffect(() => {
    api.get("/config/story").then((r) => setStory(r.data));
  }, []);

  return (
    <section
      id="story"
      data-testid="story-section"
      className="py-24 lg:py-32 border-t border-neutral-900"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-32">
          <p className="font-mono-label text-[11px] text-neutral-500 mb-4">
            04 · My Story
          </p>
          <h2
            data-testid="story-title"
            className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter"
          >
            {story.title || "Why We Charge Half"}
          </h2>
        </div>
        <div className="lg:col-span-7">
          <p
            data-testid="story-body"
            className="text-xl md:text-2xl text-neutral-300 leading-[1.5] font-light"
          >
            {story.body}
          </p>
          <div className="mt-10 grid grid-cols-3 gap-4 md:gap-8">
            <div>
              <p className="font-display font-black text-5xl md:text-6xl">50+</p>
              <p className="mt-2 font-mono-label text-[10px] text-neutral-500">
                Custom Builds
              </p>
            </div>
            <div>
              <p className="font-display font-black text-5xl md:text-6xl">1/2</p>
              <p className="mt-2 font-mono-label text-[10px] text-neutral-500">
                Corporate Price
              </p>
            </div>
            <div>
              <p className="font-display font-black text-5xl md:text-6xl">0</p>
              <p className="mt-2 font-mono-label text-[10px] text-neutral-500">
                Middlemen
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
